














import Vue from "vue"
export default Vue.extend({
	props: ['upgrade', 'active', 'choice'],
	methods: {
		click () {
			this.$emit('clicked')
		}
	}
})
